// extracted by mini-css-extract-plugin
export default {"main":"BuyButton_main__H7AFx"};